const IsFavourited = (thisID: number, pagesIds: number[]) => pagesIds.includes(thisID);

export { IsFavourited };
